import { useState, useEffect } from 'react';
import { delivery as deliveryApi } from '../api/client.js';
import FnuciBadge from '../common/FnuciBadge.jsx';

const METHOD_LABELS = {
  ocr_auto: 'OCR auto',
  ocr_rotated: 'OCR rotation',
  manual: 'Manuel',
};

/**
 * Displays scans performed today (serial, time, method, confidence).
 * Fetches from GET /api/c/:campaignId/scan/history?date=today
 */
export default function ScanHistory() {
  const [scans, setScans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    deliveryApi.scanHistory()
      .then(setScans)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="text-gray-500 text-center py-8">Chargement...</p>;
  if (error) return <p className="text-red-600 text-center py-8">{error}</p>;

  return (
    <div className="bg-white rounded-xl p-4 shadow-sm">
      <h3 className="font-bold text-lg mb-3">Scans du jour ({scans.length})</h3>
      {scans.length === 0 ? (
        <p className="text-gray-400 text-center py-4">Aucun scan aujourd'hui</p>
      ) : (
        <div className="space-y-2">
          {scans.map((scan) => (
            <ScanRow key={scan.id} scan={scan} />
          ))}
        </div>
      )}
    </div>
  );
}

/**
 * Single scan row
 * @param {{ scan: object }} props
 */
function ScanRow({ scan }) {
  const time = scan.scanned_at
    ? new Date(scan.scanned_at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
    : '--:--';
  const confidence = scan.scan_confidence != null
    ? `${Math.round(scan.scan_confidence * 100)}%`
    : '-';
  const method = METHOD_LABELS[scan.scan_method] || scan.scan_method || '-';

  return (
    <div className="flex items-center gap-3 p-2 border-b border-gray-100 last:border-0">
      <div className="flex-1 min-w-0">
        <div className="font-mono text-sm font-medium truncate">{scan.serial_number}</div>
        {scan.secondary_id && (
          <div className="text-xs text-gray-400 truncate">{scan.secondary_id}</div>
        )}
      </div>
      <div className="text-xs text-gray-500">{time}</div>
      <div className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full">{method}</div>
      <div className="text-xs text-gray-500">{confidence}</div>
      <FnuciBadge status={scan.fnuci_status} lastError={scan.fnuci_last_error} />
    </div>
  );
}
